/**
 * The label to display when selected the filter
 */
export const labelMadrelingua = {
  // madrelingua: 'madrelingua',
  livelloConoscenzaLingua: 'Lingua IT',
  livelliLingua: 'Livello conoscenza altre lingue',
};
